<template>
  <div>
    <a-breadcrumb class="m-b-md">
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>操作记录</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="list-header m-b-md">
      <span>操作人：</span>
      <a-dropdown :trigger="['click']">
        <a-input-search v-model="keyword" style="width: 150px" @focus="handleFocusSearch" @search="handleSearch" />
        <radio-user-popover
          :loading="userListLoading"
          :userList="userList"
          :total="userListPagination.total"
          @choose="handleChange"
          @loadMore="loadMore"
          slot="overlay"
        />
      </a-dropdown>
      <!-- <a-select
        showSearch
        :value="userId"
        placeholder="请输入操作人"
        style="width: 200px"
        :defaultActiveFirstOption="false"
        :showArrow="false"
        :filterOption="false"
        @search="handleSearch"
        @change="handleChange"
        :notFoundContent="null">
        <a-select-option v-for="d in userList" :key="d.id">{{d.nickname}}</a-select-option>
      </a-select> -->
      <div class="gap-20">
        <span>接口路径：</span>
        <a-input v-model="searchName" width="200" style="width: 200px" />
      </div>
      <div class="gap-20">
        <span>操作时间：</span>
        <a-range-picker
          showTime
          @change="
            (date, dateString) => {
              time.startDate = dateString[0];
              time.endDate = dateString[1];
            }
          "
          :format="dateFormat"
        />
      </div>
      <a-button @click="handleFilterList" type="primary">查询</a-button>
    </div>
    <a-table :columns="columns" :dataSource="list" :pagination="pagination" :rowKey="record => record.id" @change="handleTableChange">
      <div slot="user" slot-scope="row">
        <a-tooltip placement="right" v-if="row.user">
          <template slot="title">
            <span>{{ row.user.name }}</span>
          </template>
          <a-avatar :src="row.user.avatar" icon="user" :size="24" />
        </a-tooltip>
        <a-avatar v-else size="small" icon="user" />
      </div>
    </a-table>
  </div>
</template>
<script>
import { logList } from '@/api/systemOplog';
import { searchNickName, searchNickNamePage } from '@/api/common';
import moment from 'moment';
import debounce from 'lodash/debounce';
import RadioUserPopover from '@/components/base/RadioUserPopOver';
const columns = [
  { title: '操作人', align: 'center', width: 90, scopedSlots: { customRender: 'user' } },
  { title: '操作接口', dataIndex: 'path' },
  { title: '数据', dataIndex: 'data', width: 300 },
  { title: 'IP', dataIndex: 'ip', align: 'center' },
  { title: '浏览器', dataIndex: 'agent', width: 300 },
  { title: '操作时间', dataIndex: 'createAt', align: 'center', width: 120 }
];
export default {
  components: { RadioUserPopover },
  data() {
    this.handleSearch = debounce(this.handleSearch, 800);
    return {
      columns,
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      list: [],
      pagination: {
        page: 1,
        total: 0
      },
      userId: undefined,
      keyword: '',
      userList: [],
      userListLoading: true,
      userListPagination: {
        page: 1,
        total: 0
      },
      time: {
        start: null,
        end: null
      },
      searchName: ''
    };
  },
  methods: {
    moment,
    handleChange(e) {
      // 选择用户
      this.userId = e.id;
      this.keyword = e.nickname;
    },
    handleFocusSearch() {
      if (!this.userList.length) {
        this.handleSearch();
      }
    },
    async loadMore() {
      // 下拉加载更多用户
      this.userListLoading = true;
      this.userListPagination.page++;
      const res = await searchNickNamePage(this.keyword, this.userListPagination.page);
      this.userListLoading = false;
      this.userList = this.userList.concat(res.data.list);
      this.userListPagination.page = res.data.page;
      this.userListPagination.total = res.data.total;
    },
    handleSearch(e) {
      // 查询用户
      this.userListLoading = true;
      this.userListPagination.page = 1;
      searchNickName(e).then(res => {
        this.userList = res.data.list;
        this.userListPagination.page = res.data.page;
        this.userListPagination.total = res.data.total;
        this.userListLoading = false;
      });
    },
    handleTableChange(pagination) {
      this.pagination.page = pagination.current;
      this.handleFilterList();
    },
    handleFilterList() {
      // 筛选列表
      this.getList({
        userId: this.userId,
        startDate: this.time.startDate,
        endDate: this.time.endDate,
        searchName: this.searchName
      });
    },
    async getList(data) {
      let query;
      if (data) {
        query = Object.assign(data, this.pagination);
      }
      const res = await logList(query);
      this.list = res.data.list;
      this.pagination.total = res.data.total;
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.list-header {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
}
</style>
